module.exports = __webpack_public_path__ + "img/no_owners.5777dec9.svg";